import React from "react";
import { Tag } from "@ui5/webcomponents-react";
import { cn } from "../../../lib/cn";

/**
 * Badge component wrapping UI5 Tag
 * Used for status indicators, counts, and labels
 *
 * @param {Object} props - Component props
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.colorScheme] - UI5 color scheme (numeric "1" to "10")
 * @param {string} [props.design] - UI5 design type (e.g., "Positive", "Negative", "Set1", "Set2")
 * @param {React.ReactNode} props.children - Badge content
 * @returns {JSX.Element}
 *
 * @example
 * <Badge>New</Badge>
 * <Badge colorScheme="8">42</Badge>
 * <Badge design="Positive">Success</Badge>
 */
export function Badge({
  className,
  colorScheme,
  design,
  children,
  icon,
  ...props
}) {
  // Wrap children in flex container if there are multiple children (icon + text)
  const wrappedChildren =
    React.Children.count(children) > 1 ? (
      <span className="inline-flex items-center gap-1">{children}</span>
    ) : (
      children
    );

  return (
    <Tag
      colorScheme={colorScheme}
      design={design}
      hideStateIcon={true}
      icon={icon || undefined}
      className={cn(className)}
      {...props}
    >
      {wrappedChildren}
    </Tag>
  );
}

/**
 * Color schemes:
 * 1 - Grey
 * 2 - Red
 * 3 - Yellow
 * 4 - Green
 * 5 - Blue
 * 6 - Teal (default)
 * 7 - Purple
 * 8 - Pink
 * 9 - Indigo
 * 10 - Brown
 */
